// @flow
import * as React from 'react';
import { Trans } from '@lingui/macro';

export const CART_UPDATED = <Trans>Cart updated</Trans>;
export const ERROR_WHILE_ADDING_OUTLET = (
  <Trans>Error while adding outlet</Trans>
);
export const ERROR_WHILE_REGISTER = <Trans>Error while register</Trans>;
export const ERROR_WHILE_LOGGING_IN = <Trans>Error while logging in</Trans>;
export const ERROR_WHILE_LOADING_DATA = <Trans>Error while loading data</Trans>;
export const INVALID_OTP_PLEASE_TRY_AGAIN = (
  <Trans>Invalid OTP, Please try again</Trans>
);
export const INSUFFICIENT_STOCK_AVAILABLE_UNIT_NUMBER = (number: number) => (
  <Trans>Insufficient Stock. Available inventory {number}</Trans>
);
export const LOOKS_LIKE_YOU_HAVENT_MADE_ANY_ORDER_YET = (
  <Trans>Looks like you haven't made your order yet</Trans>
);
export const MOBILE_NUMBER_IS_REQUIRED = (
  <Trans>Mobile number is required</Trans>
);
export const NAME_IS_REQUIRED = <Trans>Name is required</Trans>;
export const DELIVERY_LOCATION_IS_REQUIRED = (
  <Trans>Delivery location is required</Trans>
);
export const LOCATION_REQUIRED_PLEASE_ALLOW_ACCESS = (
  <Trans>Location required, please allow access!</Trans>
);
export const LOCATION_REQUIRED_PLEASE_ALLOW_LOCATION = (
  <Trans>Location not available, please allow location</Trans>
);
export const NO_NETWORK = <Trans>No Network</Trans>;
export const NO_DATA_FOUND = <Trans>No data found</Trans>;
export const NO_DEALS_AVAILABLE = <Trans>No deals available</Trans>;
export const NO_REWARDS_AVAILABLE = <Trans>No rewards available</Trans>;
export const NO_NOTIFICATION_FOUND = <Trans>No notifications found</Trans>;
export const NO_RESULT_FOUND = <Trans>No result found</Trans>;
export const NO_ORDER_FOUND = <Trans>No order found</Trans>;
export const NO_PRODUCT_FOUND = <Trans>No product found</Trans>;
export const NO_NEW_BRANDS_IN_YOUR_AREA = (
  <Trans>No new brands in your area</Trans>
);
export const NO_POINT_HISTORY_AVAILABLE = (
  <Trans>No point history available</Trans>
);
export const ORDER_PLACED_SUCCESSFULLY = (
  <Trans>Order placed successfully</Trans>
);
export const OUT_OF_STOCK = <Trans>Out of stock</Trans>;
export const OTP_SENT = <Trans>OTP sent</Trans>;
export const PLEASE_CHECK_INTERNET_CONNECTIVITY = (
  <Trans>Please check internet connectivity</Trans>
);
export const PLEASE_ENTER_VALID_EMAIL = <Trans>Please enter valid email</Trans>;
export const PLEASE_ENTER_VALID_PINCODE = (
  <Trans>Please enter valid pincode</Trans>
);
export const PLEASE_ENTER_VALID_MOBILE_NUMBER = (
  <Trans>Please enter valid mobile number</Trans>
);
export const PLEASE_TRY_AGAIN_LATER = <Trans>Please try again later</Trans>;
export const REMOVED_FROM_CART = <Trans>Removed from cart</Trans>;
export const RESPONSE_SAVED_SUCCESSFULLY = (
  <Trans>Response saved successfully</Trans>
);

export const SOMETHING_WENT_WRONG = <Trans>Something went wrong</Trans>;
export const SUCCESS_PLEASE_LOGIN = <Trans>Success, Please Login</Trans>;
export const THIS_FIELD_IS_REQUIRED = <Trans>This field is required</Trans>;
export const THIS_NUMBER_IS_ALREADY_IN_USE = (
  <Trans>This number is already in use</Trans>
);
export const TRY_ANOTHER_NUMBER_ITS_SAME_AS_LOGGED_IN_NUMBER = (
  <Trans>Try another number, it's same as logged in number</Trans>
);
export const THIS_NUMBER_IS_NOT_REGISTERED = (
  <Trans>This number is not registered</Trans>
);
export const TO_VIEW_ORDER_STUTUS_GO_TO = (
  <Trans>To view order status go to</Trans>
);
export const YOUR_CART_IS_EMPTY = <Trans>Your cart is empty</Trans>;
export const YOU_DONT_HAVE_ANY_BRANDS_YET = (
  <Trans>You don't have any brands yet</Trans>
);
export const YOU_DONT_HAVE_ANY_OUTLET_YET = (
  <Trans>You don't have any outlet yet</Trans>
);
export const YOU_DONT_HAVE_ANY_ACTIVE_BRAND_YET = (
  <Trans>You don't have any active brand yet</Trans>
);
export const YOU_HAVENT_PLACE_ANY_ORDER_YET = (
  <Trans>You haven't placed any order yet</Trans>
);
export const YOU_HAVENT_CLAIM_ANY_DEALS_YET = (
  <Trans>You haven't claim any deals yet</Trans>
);

export const NO_PAYMENTS_FOUND = <Trans>No payment found</Trans>;
export const NO_RETURN_REQUEST_FOUND = <Trans>No return request found</Trans>;
export const DOESNT_SUPPORT_PAYMENT = <Trans>Doesn't support payment</Trans>;
export const PLEASE_ENTER_MANDATORY_INFORMATION = (
  <Trans>Please enter mandatory information</Trans>
);
export const PRODUCT_ALREADY_EXISTS = <Trans>Product already exists</Trans>;
export const CHECK_THE_SPACE_TO_KNOW_ABOUT_YOUR_ORDERS_AND_PAYMENTS = (
  <Trans>Check this space to know about your orders and payments</Trans>
);
export const WRONG_APP_IDENTIFIER = <Trans>Wrong app identifier</Trans>;
export const INSUFFICIENT_DATA_PROVIDED = (
  <Trans>Insufficient data provided</Trans>
);
export const AUTHENTICATION_TOKEN_NOT_VALID = (
  <Trans>Authentication token not valid</Trans>
);
export const AUTHENTICATION_TOKEN_HAS_EXPIRED = (
  <Trans>Authentication token has expired</Trans>
);
export const USER_DETAILS_ARE_NOT_VALID = (
  <Trans>User details are not valid</Trans>
);
export const UNKNOWN_ERROR = <Trans>Unknown error</Trans>;
export const USER_ALREADY_EXISTS_WITH_THIS_OUTLET = (
  <Trans>User already exists with this outlet</Trans>
);
export const ADMIN_CANNOT_BE_REMOVED_MESSAGE = (
  <Trans>
    Admin cannot be removed! If you want to remove, make this as a member and
    then try to remove.
  </Trans>
);
export const NO_REPORTS_FOUND_MESSAGE = (
  <Trans>No reports and dashboard are available for this brand</Trans>
);
